import { Box, BoxProps, Flex } from '@pancakeswap/uikit'
import styled, { css } from 'styled-components'

const Wrapper = styled(Flex)`
  overflow-x: scroll;
  padding: 0;
  // border-radius: 24px 24px 0 0;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none; /* Firefox */
`

const Inner = styled(Flex)`
  justify-content: space-between;
  // background-color: ${({ theme }) => theme.colors.input};
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px;
`

interface TabProps extends BoxProps {
  isActive?: boolean
  onClick?: () => void
}

export const TabToggle = styled(Box).attrs({
  as: 'button',
})<TabProps>`
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  flex: 1;
  border: 0;
  outline: 0;
  margin: 0;
  height: 40px;
  border-radius: 16px;

  // color: ${({ theme, isActive }) => (isActive ? theme.colors.text : theme.colors.textSubtle)};
  // background-color: ${({ theme, isActive }) => (isActive ? theme.card.background : theme.colors.input)};
  padding: 0px;
  color: ${({ isActive }) => (isActive ? '#000000!important' : 'rgba(255, 255, 255, 0.65)')};
  background-color: ${({ isActive }) => (isActive ? '#ffc9b1' : 'transparent')};

  div {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }
  box-shadow: none;
  ${({ isActive }) =>
    isActive &&
    css`
      div {
        color: #000;
      }
    `}
`

TabToggle.defaultProps = {
  // p: '16px',
}

interface TabToggleGroupProps {
  children: React.ReactElement[]
}

export const TabToggleGroup: React.FC<React.PropsWithChildren<TabToggleGroupProps>> = ({ children }) => {
  return (
    <Wrapper
      p={['0 4px', '0 16px']}
      style={{ margin: '24px', background: 'rgba(255, 255, 255, 0.08)', borderRadius: '16px' }}
    >
      <Inner>{children}</Inner>
    </Wrapper>
  )
}
